import {writable} from 'svelte/store';

export const AppState = writable(null); 

export const AppCache = writable({});